import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["disabled", "format", "parse", "simple", "onFocus", "onBlur", "onKeyDown"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file InputNumber
 */
import React, { useCallback, useState } from 'react';
import { useDownStep, usePrecisionValue, useUpStep } from '@tencent/glue-react-region';
import { AxisType } from '@tencent/glue-model-region';
import { useCombineCallback } from '@tencent/glue-react-use';
import { ViewInputNumber } from '../../views/ViewInputNumber';
import { withInputWrapper } from '../../hoc/withInputWrapper';

function preventDefault(e) {
  e.preventDefault();
}

var InputContent = withInputWrapper(function (props) {
  var extra = Object.assign({}, props);
  delete extra.onClear;
  var Comp = ViewInputNumber;
  return React.createElement(Comp, _objectSpread({}, extra));
});
export function InputNumberContent(props) {
  var _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      format = props.format,
      parse = props.parse,
      simple = props.simple,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onKeyDown = props.onKeyDown,
      extra = _objectWithoutProperties(props, _excluded);

  var _usePrecisionValue = usePrecisionValue('end', AxisType.HORIZONTAL, format, parse),
      _usePrecisionValue2 = _slicedToArray(_usePrecisionValue, 3),
      inputValue = _usePrecisionValue2[0],
      onChange = _usePrecisionValue2[1],
      checkInputValid = _usePrecisionValue2[2];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useUpStep = useUpStep('end', AxisType.HORIZONTAL),
      _useUpStep2 = _slicedToArray(_useUpStep, 2),
      disabledUp = _useUpStep2[0],
      onUp = _useUpStep2[1];

  var _useDownStep = useDownStep('end', AxisType.HORIZONTAL),
      _useDownStep2 = _slicedToArray(_useDownStep, 2),
      disabledDown = _useDownStep2[0],
      onDown = _useDownStep2[1];

  var onUpClick = useCallback(function () {
    if (disabled || disabledUp) {
      return;
    }

    onUp();
  }, [disabledUp, disabled]);
  var onDownClick = useCallback(function () {
    if (disabled || disabledDown) {
      return;
    }

    onDown();
  }, [disabledDown, disabled]);
  var onInputKeyDown = useCombineCallback(function (e) {
    if (e.keyCode === 38 && !disabled && !disabledUp) {
      onUp();
    }

    if (e.keyCode === 40 && !disabled && !disabledDown) {
      onDown();
    }
  }, onKeyDown);
  var onInputFocus = useCombineCallback(function () {
    return setFocus(true);
  }, onFocus);
  var onInputBlur = useCombineCallback(function () {
    return setFocus(false);
  }, checkInputValid, onBlur);
  return React.createElement(InputContent, _objectSpread(_objectSpread({}, extra), {}, {
    simple: simple,
    focus: focus,
    value: inputValue,
    disabled: disabled,
    disabledUp: disabled || disabledUp,
    disabledDown: disabled || disabledDown,
    onUpClick: onUpClick,
    onDownClick: onDownClick,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    onKeyDown: onInputKeyDown,
    onUpMouseDown: preventDefault,
    onDownMouseDown: preventDefault,
    onValueChange: onChange
  }));
}